import React from "react";
import { Link } from "react-router-dom";
import {
  ImgAsesoriasContables,
  ImgAuditoriaComunidades,
  ImgCreacionEmpresa,
  ImgRenta,
  ImgTributario,
} from "../../images/servicios";

const ModernServices = () => {
  const services = [
    {
      title: "Planificación de Renta 2027",
      description:
        "Nos encargaremos de recomendar todos los beneficios tributarios aplicables a tu empresa para maximizar tus beneficios.",
      icon: "fas fa-search-dollar",
      image: ImgRenta,
      link: "/servicios/planificacion-renta-2027",
      color: "#3b82f6",
    },
    {
      title: "Asesoría Contable",
      description:
        "Somos especialistas en Asesoría Tributaria, Laboral, Contable y Legal con años de experiencia en el mercado.",
      icon: "fas fa-balance-scale",
      image: ImgAsesoriasContables,
      link: "/servicios/asesorias-contables",
      color: "#06b6d4",
    },
    {
      title: "Auditoria de Comunidades",
      description:
        "Especialistas en Edificios y Condominios con servicios integrales para comunidades residenciales.",
      icon: "fas fa-users",
      image: ImgAuditoriaComunidades,
      link: "/servicios/auditoria-comunidades",
      color: "#8b5cf6",
    },
    {
      title: "Creación de Empresa",
      description:
        "Es importante constituir tu empresa, porque te permitirá separar el patrimonio de tu negocio del personal.",
      icon: "fas fa-user-tie",
      image: ImgCreacionEmpresa,
      link: "/servicios/creacion-empresa",
      color: "#10b981",
    },
    {
      title: "Diagnóstico Tributario",
      description:
        "Realizamos un cumplimiento tributario conforme a la legislación nacional para optimizar tus procesos.",
      icon: "fas fa-dollar-sign",
      image: ImgTributario,
      link: "/servicios/diagnostico-tributario",
      color: "#f59e0b",
    },
  ];

  return (
    <section className="section-modern" id="nuestros_servicios">
      <div className="auto-container">
        <div className="section-header-modern">
          <div className="section-header-modern-subtitle">Lo que ofrecemos</div>
          <h2 className="section-header-modern-title">Nuestros Servicios</h2>
          <p className="section-header-modern-description">
            Ofrecemos soluciones integrales en contabilidad, tributación y
            auditoría con un enfoque moderno y personalizado para cada cliente.
          </p>
        </div>

        <div className="services-grid-modern">
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card-modern animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="service-card-modern-image">
                <img src={service.image} alt={service.title} />
                <div className="service-card-overlay">
                  <Link to={service.link} className="service-card-overlay-link">
                    Ver detalles
                    <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
              <div className="service-card-modern-content">
                <div
                  className="service-card-modern-icon"
                  style={{
                    background: `linear-gradient(135deg, ${service.color}, ${service.color}aa)`,
                  }}
                >
                  <i className={service.icon}></i>
                </div>
                <h3 className="service-card-modern-title">{service.title}</h3>
                <p className="service-card-modern-description">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ModernServices;
